import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const AccountInfo = ({ guid, iamPatientAcceptance }) => {
  const ccmStatusOptionsByRole = iamPatientAcceptance
    ? forms.ccmStatusOptionsForPatientAcceptanceRole
    : forms.ccmStatusOptions;

  const ccmStatusOptions = useMemo(() => [...ccmStatusOptionsByRole]);

  return (
    <div className="admin-patient-form-block">
      <span>Account Info</span>
      <Row>
        <Col lg="12" md="12" sm="12" xs="12">
          <div className="label">Patient ID</div>
          <div>{guid}</div>
        </Col>
      </Row>
      <Row>
        <Col lg="6" md="6" sm="6" xs="12">
          <Input
            label="RPM Status"
            id="status"
            type="select"
            options={forms.patientStatuses}
          />
        </Col>
        <Col lg="6" md="6" sm="6" xs="12">
          <Input
            label="PCM Status"
            id="pcmStatus"
            type="select"
            options={forms.pcmStatuses}
          />
        </Col>
      </Row>
      <Row>
        <Col lg="6" md="6" sm="6" xs="12">
          <Input
            label="CCM status"
            id="ccmStatus"
            type="select"
            options={ccmStatusOptions}
          />
        </Col>
      </Row>
    </div>
  );
};

AccountInfo.propTypes = {
  guid: PropTypes.string.isRequired,
  iamPatientAcceptance: PropTypes.bool,
};

export default AccountInfo;
